import classNames from 'classnames'
import React from 'react'

import RichText from '../../components/rich-text'
import ButtonNew from '../ButtonNew/ButtonNew'

import { HEADER_CONTENT_VARIANT } from './HeaderContentBlock.const'
import { LazyImage } from '@/src/components/images'

const HeaderContentBlock = ({
  title,
  content,
  action,
  variant = HEADER_CONTENT_VARIANT.GREY,
  textTokens = {},
  image
}) => {
  if (image) {
    return (
      <LazyImage
        priority
        width={'325'}
        height={'260'}
        src={image.url}
        alt={image.title}
        style={{
          borderRadius: '24px',
          objectFit: 'cover'
        }}
      />
    )
  }
  return (
    <div
      className={classNames('c-header-content-block', {
        'c-header-content-block--green': variant === HEADER_CONTENT_VARIANT.green
      })}
    >
      {title ? <h5>{title}</h5> : null}
      {content && (
        <div className="c-header-content-block__content">
          <RichText data={content} tokens={textTokens} />
        </div>
      )}
      {action && action.url && action.label && (
        <ButtonNew
          url={action.url}
          classes="c-header-content-block__action-button"
          variant={'secondary'}
          size="md"
        >
          {action.label}
        </ButtonNew>
      )}
    </div>
  )
}

export default HeaderContentBlock
